<template class="full-height">
  <div class="member-container full-height">
    <!-- 審核 -->
    <el-dialog
      :top="'5%'"
      v-loading="listLoading"
      :visible.sync="dialogPictureFormVisible"
      :title="'審核'"
      @closed="onDialogClosed"
    >
      <el-card class="box-card">
        <el-steps :active="active" finish-status="success">
          <el-step title="步骤 1"></el-step>
          <el-step title="步骤 2"></el-step>
        </el-steps>

        <el-alert type="info" :closable="false"
          >請注意，資料為一步一步建立，無返回上一步的操作!</el-alert
        >

        <template v-if="active == 0">
          <p>審核該申請者提交的證照正確性後，請點選下一步。</p>
          <template v-if="pictureData && pictureData.length">
            <template v-for="(item, index) in pictureData[0].files">
              <span :key="index">{{ item.fileName }}</span>
              <img
                :key="index"
                width="100%"
                :src="item.url"
                alt=""
                style="margin-top: 10px; margin-bottom: 20px"
              />
            </template>
          </template>
          <el-button type="primary" @click="verify(true)">審核通過</el-button>
          <el-button type="danger" @click="verify(false)">審核不通過</el-button>
        </template>
        <template v-if="active == 1">
          <div style="margin: 20px 0px">
            <tinymce ref="tinymce" v-model="emailContent" :height="500" :type="31" />
          </div>
          <el-button type="primary" @click="saveEmail">寄送信件</el-button>
          <el-button type="danger" @click="onDialogClosed">取消</el-button>
        </template>

        <!-- <template v-if="active == 1 && verifyResult">
          <el-form
            :rules="introRules"
            size="mini"
            ref="introductionForm"
            :model="roleSettingObj"
            :label-width="formLabelWidth"
          >
            <el-form-item label="頭貼" :label-width="formLabelWidth">
              <div>
                <span>尺寸:70*70</span>
                <Upload
                  ref="uploadRef"
                  :accept="'.jpg,.jpeg,.png'"
                  :payload="roleSettingObj"
                  :limit-file-count="1"
                  :data-obj="fileObj"
                  :use-drag="false"
                  :action="'ToursCombine/saveIntroAvatar'"
                  :auto-upload="false"
                  :show-file-list="true"
                  :form-on-loading-parent="listLoading"
                  :btn-txt="'上傳'"
                  :before-file-list="
                    roleSettingObj.fileInfo && roleSettingObj.fileInfo.length
                      ? roleSettingObj.fileInfo[0].files
                      : []
                  "
                />
              </div>
            </el-form-item>

            <el-form-item :label="'名稱'" prop="authorName">
              <el-input
                v-model="roleSettingObj.authorName"
                maxlength="50"
                show-word-limit
              ></el-input>
            </el-form-item>

            <el-form-item :label="'簡介'" prop="introduction">
              <el-input
                type="textarea"
                v-model="roleSettingObj.introduction"
                :autosize="{ minRows: 4, maxRows: 4 }"
              ></el-input>
            </el-form-item>

            <el-form-item :label="'排序'" prop="sort">
              <el-input v-model="roleSettingObj.sort"></el-input>
            </el-form-item>

            <el-form-item
              v-for="(social, index) in roleSettingObj.socialLinkList"
              :label="'社群' + (index + 1)"
              :key="index"
              :prop="'social.' + index + '.id'"
            >
              <el-select v-model="social.socialType" placeholder="請選擇">
                <el-option
                  v-for="item in socialLinkSelectList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-input v-model="social.url" style="width: 50%"></el-input>
              <el-button @click.prevent="removeSocialLink(social)"
                >删除</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button @click="addSocialLink">新增社群</el-button>
            </el-form-item>
          </el-form>
          <el-button
            type="primary"
            @click="saveIntroduction('introductionForm')"
            >確定</el-button
          >
          <el-button type="danger" @click="onDialogClosed">取消</el-button>
        </template> -->
      </el-card>
    </el-dialog>

    <div style="padding: 20px; padding-bottom: 0" class="full-height">
      <div style="padding-bottom: 0">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item label="搜尋">
            <el-input
              size="mini"
              v-model="listQuery.qry"
              placeholder="輸入查詢"
              @keyup.enter.native="handleFilter"
            />
          </el-form-item>

          <el-form-item>
            <el-button
              size="mini"
              class="filter-item"
              type="primary"
              icon="el-icon-search"
              @click="handleFilter"
            >
              搜尋
            </el-button>
            <!-- <el-button
                v-if="title == 'TCLeader'"
                type="danger"
                size="mini"
                @click="showReviewList"
                >人工審核【{{ manuallyCount }}】</el-button
              > -->
          </el-form-item>
        </el-form>
      </div>

      <div style="position: relative; height: 80%">
        <el-table
          :key="tableKey"
          v-loading="listLoading"
          size="mini"
          :data="list"
          border
          fit
          highlight-current-row
          height="100%"
          @sort-change="sortChange"
        >
          <el-table-column :label="'ID'" prop="id" sortable="custom" align="center" width="80">
            <template slot-scope="{ row }">
              <span>{{ row.id }}</span>
            </template>
          </el-table-column>

          <el-table-column
            :label="'帳號'"
            prop="account"
            sortable="custom"
            align="left"
            width="130"
          >
            <template slot-scope="{ row }">
              <span>{{ row.account }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'姓名'" prop="name" sortable="custom" align="center" width="130">
            <template slot-scope="{ row }">
              <span>{{ row.name }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'mail'" prop="mail" align="center" width="130">
            <template slot-scope="{ row }">
              <span>{{ row.mail }}</span>
            </template>
          </el-table-column>

          <el-table-column
            :label="'角色'"
            prop="roles"
            sortable="custom"
            align="center"
            width="130"
          >
            <template slot-scope="{ row }">
              <span>{{ row.roles.toString() }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="狀態" width="120">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status == 0 ? 'danger' : 'success'">{{
                scope.row.status == 0 ? '停用' : '啟用'
              }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column align="center" :label="'操作'" width="200">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="primary"
                icon="el-icon-edit"
                @click="viewPicture(scope.row)"
              >
                審核
              </el-button>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            :label="'刪除'"
            width="200"
            v-if="checkPermission(['ITA-DEV'])"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="danger"
                icon="el-icon-delete"
                @click="deleteMember(scope.row)"
              >
                刪除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        v-show="total > 0"
        style="padding-top: 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import {
  getTcMembers,
  saveRoles,
  deleteMember,
  getTcRoles,
  saveTcData,
  getPendingReviewLeaderList,
} from '@/api/member'
import waves from '@/directive/waves' // waves directive
import Pagination from '@/components/Pagination' // secondary package based on el-pagination
import Upload from '@/views/ita/components/fileUpload.vue'
import checkPermission from '@/utils/permission' // 权限判断函数
import Tinymce from '@/components/Tinymce'
import {
  getIntroduction,
  getIntroductionTypeList,
  getLeaderLicense,
  saveIntroduction,
  sendEmail,
  verifyLeader,
} from '@/api/tcSetting'

var defaultIntroductionFormData = {
  id: null,
  authorName: '',
  introduction: '',
  sort: 99,
  socialLinkList: [],
  fileInfo: [],
}

export default {
  name: 'Member',
  components: { Pagination, Upload, Tinymce },
  directives: { waves },
  data() {
    return {
      introRules: {
        authorName: [{ required: true, message: '請輸入名稱', trigger: 'blur' }],
        introduction: [{ required: true, message: '請輸入簡介', trigger: 'blur' }],
      },
      fileObj: { id: 0, type: 'agencyInfo', user: '' },
      formLabelWidth: '120px',
      roleSettingObj: {},
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 30,
        sort: '-cUpdateDT',
      },
      dialogPictureFormVisible: false,
      socialLinkSelectList: [],
      selectedUser: null,
      active: 0,
      pictureData: {},
      emailContent: '',
      //verifyResult: false,
    }
  },
  async created() {
    //await this.getIntroSelectType();
    await this.getList()
  },
  methods: {
    // async getCount() {
    //   var result = await getManuallyCount();
    //   this.manuallyCount = result.data;
    // },
    next() {
      if (this.active++ > 1) {
        this.active = 0
      }
    },
    async verify(value) {
      //this.verifyResult = value;
      if (!confirm(`確定該導遊的審核結果為【${value ? '通過' : '不通過'}】?`)) {
        return
      }
      if (!value) {
        this.next()
        return false
      }
      this.loadingHanlder(true)
      await verifyLeader({ id: this.selectedUser })
        .then(resp => {
          if (resp.success) {
            this.$message({
              message: '操作成功',
              type: 'success',
            })
          }
          this.loadingHanlder(false)
          this.next()
        })
        .catch(error => {
          this.loadingHanlder(false)
        })
    },
    // async getIntroSelectType() {
    //   this.socialLinkSelectList = await getIntroductionTypeList();
    // },
    async deleteMember(row) {
      let vm = this
      if (confirm(`確定刪除【${row.name}】使用者資訊?\r\n`)) {
        vm.loadingHanlder(true)
        let resp = await deleteMember({ id: row.id })
        if (resp.success) {
          await vm.getList()
          vm.$message({
            message: '操作成功',
            type: 'success',
          })
        }
        vm.loadingHanlder(false)
      }
    },
    loadingHanlder(action) {
      let vm = this
      if (vm.listLoading != action) {
        vm.listLoading = action
      }
    },
    checkPermission,

    async viewPicture(row) {
      this.loadingHanlder(true)
      await getLeaderLicense({ id: row.id })
        .then(response => {
          console.log(response)
          this.pictureData = response.data
          this.dialogPictureFormVisible = true
          this.selectedUser = row.id
          this.loadingHanlder(false)
        })
        .catch()
    },
    async saveEmail() {
      this.loadingHanlder(true)
      await sendEmail({
        id: this.selectedUser,
        content: this.emailContent,
      })
        .then(response => {
          console.log(response)
          this.loadingHanlder(false)
          this.$message({
            message: '操作成功',
            type: 'success',
          })
          this.onDialogClosed()
        })
        .catch(error => {})
    },

    // async editIntroductionInfo(row) {
    //   //透過api取得
    //   let vm = this;
    //   vm.listLoading = true;
    //   await getIntroduction(row.id)
    //     .then((response) => {
    //       console.log(response);
    //       if (response.data == null) {
    //         vm.roleSettingObj = JSON.parse(
    //           JSON.stringify(defaultIntroductionFormData)
    //         );
    //       } else {
    //         vm.roleSettingObj = JSON.parse(JSON.stringify(response.data));
    //       }
    //       vm.listLoading = false;
    //       //vm.dialogIntroFormVisible = true;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },

    // saveIntroduction(formName) {
    //   if (!confirm("確定儲存資料?")) {
    //     return;
    //   }
    //   let vm = this;
    //   let refUpload = this.$refs["uploadRef"];
    //   this.$refs[formName].validate(async (valid) => {
    //     if (valid) {
    //       vm.loadingHanlder(true);
    //       let payload = await refUpload.combineFileAndPayload();
    //       if (!payload) {
    //         alert("檔案繫結表單發生未知錯誤，無法儲存資料。");
    //         return false;
    //       }
    //       console.log(payload);
    //       payload.bindUser = vm.selectedUser;
    //       await saveIntroduction(payload)
    //         .then((response) => {
    //           vm.onDialogClosed();
    //           vm.loadingHanlder(false);
    //           this.$message({
    //             message: "操作成功",
    //             type: "success",
    //           });
    //           this.next();
    //         })
    //         .catch((error) => {});
    //     }
    //   });
    // },
    // addSocialLink() {
    //   this.roleSettingObj.socialLinkList.push({
    //     id: null,
    //     socialType: 1,
    //     url: "",
    //   });
    // },
    // removeSocialLink(item) {
    //   var index = this.roleSettingObj.socialLinkList.indexOf(item);
    //   if (index !== -1) {
    //     this.roleSettingObj.socialLinkList.splice(index, 1);
    //   }
    // },

    async getList() {
      this.loadingHanlder(true)
      var res = await getPendingReviewLeaderList(this.listQuery)
      this.list = res.data.data
      this.total = res.data.total
      this.loadingHanlder(false)
    },
    onDialogClosed() {
      // let refUpload = this.$refs["uploadRef"];
      // refUpload.clearFiles();
      // this.$refs["introductionForm"].clearValidate();
      if (this.$refs['tinymce'] !== undefined && this.$refs['tinymce'] !== null) {
        this.$refs['tinymce'].setValue('')
      }

      // this.roleSettingObj = JSON.parse(
      //   JSON.stringify(defaultIntroductionFormData)
      // );
      this.dialogPictureFormVisible = false
      this.active = 0
    },

    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    sortChange(data) {
      const { prop, order } = data
      this.sortByColumn(prop, order)
    },
    sortByColumn(sort, order) {
      if (order === 'ascending') {
        this.listQuery.sort = `+${sort}`
      } else if (order === 'descending') {
        this.listQuery.sort = `-${sort}`
      } else {
        const s = this.listQuery.sort[0]
        if (s === '+') {
          this.listQuery.sort = `-${sort}`
        } else if (s === '-') {
          this.listQuery.sort = `+${sort}`
        } else {
          this.listQuery.sort = `+${sort}`
        }
      }
      this.handleFilter()
    },
  },
}
</script>
<style scope>
.full-height {
  position: relative;
  height: 100%;
}
</style>
